import React,{useState} from 'react'
import { Container, Form, Button, Image, Row, Col, Nav, NavDropdown } from 'react-bootstrap';
import SideNav from '../components/SideNav';
import StepProgress from '../components/StepProgress';
import OrderTabs from '../components/OrderTabs';
import { useParams, useLocation } from 'react-router-dom';

function ProjectOverview() {

  const location = useLocation();           
  const orderData = location.state?.order;


  const [activeFilter, setActiveFilter] = useState('all');
  const projectSteps = [
    'KYC',
    '3D modelling',
    'Material Selection',
    'Costing',
    'Payment Collection',
    'Render',
    'Validation',
    'Prod Drawing , QC , and sign off',
    'Civil Work',
    'Kick Start Modular Work',
    'Modular Work',
    'Final QC',
    'Handover'
  ];
  const currentStep = orderData?.steps ?? 0;
  return (
    <Container fluid className='p-3' style={{ height: "100vh", }}>
    <Row>
        <Col className='col-auto'>
           <SideNav />
        </Col>
        <Col style={{ padding: "0px 10px 0px 20px",flexGrow:1}}>
            <Row className='p-2' style={{ backgroundColor: "#fff", borderRadius: '10px', alignItems: "center", justifyContent: "spaceBetween" }}>
                <Col className='col-2'><h5 style={{ color: "#000", whiteSpace: "nowrap",overflow: "hidden",textOverflow: "ellipsis", maxWidth: "180px" }}>{orderData ? orderData.name : null} </h5></Col>
                <Col className='col-8'><StepProgress
                      steps={projectSteps}
                      currentStep={currentStep}
                      completedColor="#dc2626"    // Red for completed steps
                      inProgressColor="#fbbf24"   // Yellow for the current step
                      incompleteColor="#e5e7eb"   
                      style={{color:'#000'}} // Light gray for incomplete steps
                      /></Col>
                {/* <Col><Button style={{ backgroundColor: "#e85b13", borderColor: '#e85b13' }}>Change Stage</Button></Col> */}
                <Col className="col-2 d-flex justify-content-end align-items-center">
                    <Image src={require('../assets/bell (1).png')} roundedCircle style={{ width: '25px', height: 'auto', marginRight: '5px' }} />
                    <Image src={require('../assets/user.jpg')} roundedCircle style={{ width: '40px', height: 'auto' }} />
                </Col>
            </Row>
            {/* <Row className='p-2 mt-2' style={{ backgroundColor: "#154889", borderRadius: '10px', alignItems: "center", justifyContent: "spaceBetween" }}>
                <Col><h5 style={{ color: "white" }}>Project Name</h5></Col>
                <Col className='p-0'>
                    
               <StepProgress
steps={projectSteps}
currentStep={currentStep}
completedColor="#dc2626"    // Red for completed steps
inProgressColor="#fbbf24"   // Yellow for the current step
incompleteColor="#e5e7eb"   // Light gray for incomplete steps
/>
                </Col>
                <Col className="d-flex justify-content-end align-items-center"><Button style={{ backgroundColor: "#e85b13", borderColor: '#e85b13' }}>Change Stage</Button></Col>

            </Row> */}
            <Row className='p-2 mt-2' style={{ backgroundColor: "#fff", borderRadius: '10px', alignItems: "center", justifyContent: "spaceBetween" }}>
           
            <Col>
         <OrderTabs />
            </Col>
            </Row>

        </Col>
    </Row>
</Container>
  )
}

export default ProjectOverview